// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoDots } from '../../../assets/images/Logos/logo-dots.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoDotsIcon = /* @__PURE__ */ withLogoClass(LogoDots);
